import { render, staticRenderFns } from "./covidUserCard.vue?vue&type=template&id=63bd255b&"
import script from "./covidUserCard.vue?vue&type=script&lang=js&"
export * from "./covidUserCard.vue?vue&type=script&lang=js&"
import style0 from "./covidUserCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports